<template>
    <div>
        <!--        <el-form-item label="最大星数">-->
        <!--            <el-input-number v-model="data.max"-->
        <!--                             controls-position="right"-->
        <!--                             placeholder="最大星数"></el-input-number>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="是否显示文本"-->
        <!--                      label-width="110px">-->
        <!--            <el-switch v-model="data.showText"></el-switch>-->
        <!--        </el-form-item>-->
        <el-form-item label="选项文本" label-width="110px" v-if="data.showText">
            <!--            <el-tag :key="index"-->
            <!--                    size="small"-->
            <!--                    v-for="(tag,index) in data.texts"-->
            <!--                    closable-->
            <!--                    @close="handleTextClose(tag)">{{tag}}-->
            <!--            </el-tag>-->
            <el-tag :key="index" size="small" v-for="(tag, index) in data.texts">{{ tag }}
            </el-tag>
            <!--            <el-input class="input-new-tag"-->
            <!--                      v-if="textVisible"-->
            <!--                      v-model="textValue"-->
            <!--                      size="mini"-->
            <!--                      ref="textTag"-->
            <!--                      clearable-->
            <!--                      @keyup.enter.native="handleTextConfirm"-->
            <!--                      @blur="handleTextConfirm">-->
            <!--            </el-input>-->
            <!--            <el-button v-if="!textVisible && data.texts.length < data.max"-->
            <!--                       @click="showTextInput"-->
            <!--                       size="mini"-->
            <!--                       icon="el-icon-plus"-->
            <!--                       circle-->
            <!--                       style="margin-left: 5px;"></el-button>-->
        </el-form-item>

        <el-form-item label="设置不满意项原因" label-width="110px" v-if="paperType && paperType == '1'">
            <el-button @click="showTabPanl" size="mini" style="margin-left: 5px;">设置
            </el-button>
        </el-form-item>
        

        <!--        <el-form-item label="自定义颜色"-->
        <!--                      label-width="110px">-->
        <!--            <el-tag :key="index"-->
        <!--                    v-for="(tag,index) in data.colors"-->
        <!--                    closable-->
        <!--                    size="small"-->
        <!--                    @close="handleColorClose(tag)"-->
        <!--                    :style="{color: tag}">{{tag}}-->
        <!--            </el-tag>-->

        <!--            <el-color-picker v-model="colorValue"-->
        <!--                             size="mini"-->
        <!--                             @change="handleColorConfirm"-->
        <!--                             class="color-picker"></el-color-picker>-->
        <!--        </el-form-item>-->
        <!--    <el-form-item label="自定义图标">-->
        <!--      <el-tag :key="index" v-for="(tag,index) in data.iconClasses" closable @close="handleIconClose(tag)">{{tag}}-->
        <!--      </el-tag>-->
        <!--      <el-input class="input-new-tag"-->
        <!--                v-if="iconVisible"-->
        <!--                v-model="iconValue"-->
        <!--                size="mini"-->
        <!--                ref="iconTag"-->
        <!--                @keyup.enter.native="handleIconConfirm"-->
        <!--                @blur="handleIconConfirm">-->
        <!--      </el-input>-->
        <!--      <el-button v-else @click="showIconInput" size="mini" icon="el-icon-plus" circle-->
        <!--                 style="margin-left: 5px;"></el-button>-->
        <!--    </el-form-item>-->
        <!--        <el-form-item label="是否禁用">-->
        <!--            <el-switch v-model="data.disabled"></el-switch>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="是否可见">-->
        <!--            <el-switch v-model="data.display"></el-switch>-->
        <!--        </el-form-item>-->
        <el-form-item label="是否必填">
            <el-switch v-model="data.required"></el-switch>
        </el-form-item>
        <el-form-item label="自定义题目" label-width="110px" v-if="paperType && paperType == '1'">
            <el-input size="mini" v-model="data.topic.label" placeholder="题目名称">
            </el-input>
        </el-form-item>
        <setRateTab ref="setRateTab" @change="handleChangeData" />

    </div>

</template>

<script>

import setRateTab from '../mixins/setRateTab'

export default {
    name: "config-rate",
    props: ['data'],
    components: { setRateTab },
    data() {
        return {
            validator: {
                type: null,
                required: null,
                pattern: null,
                length: null
            },
            textVisible: false,
            textValue: '',
            colorVisible: false,
            colorValue: '',
            iconVisible: false,
            iconValue: '',
            headersConfig: [],
            option: {
                column: [{
                    type: 'input',
                    prop: 'key',
                    label: 'key'
                }, {
                    prop: 'value',
                    label: 'value'
                }]
            },
            paperType: undefined

        }
    },

    mounted() {
        let routeParams = this.$routerParamsDecrypt(this.$route.params.routeParams || {});
        this.$set(this, 'paperType', routeParams.type);
    },

    methods: {
        handleChangeData(value = []) {
            const valueTexts = this.data.texts.map(item => Object.assign({}, { label: item, value: [] }));
            this.$set(this.data, 'signs', [...value, ...valueTexts].reduce((pre, cur) => {
                const data = pre.filter(item => item.label === cur.label)
                if (data.length > 0) {
                    return pre;
                } else {
                    return [...pre, cur]
                }
            }, []));
            console.log(this.data);
        },
        generateRule() {
            const rules = [];
            Object.keys(this.validator).forEach(key => {
                if (this.validator[key]) rules.push(this.validator[key])
            })
            this.data.rules = rules
        },
        handleTextClose(tag) {
            this.data.texts.splice(this.data.texts.indexOf(tag), 1);
        },
        showTextInput() {
            this.textVisible = true;
            this.$nextTick(() => {
                this.$refs.textTag.$refs.input.focus();
            });
        },

        showTabPanl() {
            this.textVisible = true;
            this.$nextTick(() => {
                if (this.data.signs != undefined && this.data.signs.length > 0) {
                    this.$refs.setRateTab.showSigns([].concat(this.data.signs[0]).concat(this.data.signs[1]).concat(this.data.signs[2]));
                } else {
                    this.$refs.setRateTab.showTab([].concat(this.data.texts[0]).concat(this.data.texts[1]).concat(this.data.texts[2]));
                }
            });
        },


        handleTextConfirm() {
            if (this.textValue) this.data.texts.push(this.textValue);
            this.textVisible = false;
            this.textValue = '';
        },
        handleColorClose(tag) {
            this.data.colors.splice(this.data.colors.indexOf(tag), 1);
        },
        handleColorConfirm() {
            if (this.colorValue) this.data.colors.push(this.colorValue);
            this.colorValue = '';
        },
        // handleIconClose(tag) {
        //   this.data.iconClasses.splice(this.data.iconClasses.indexOf(tag), 1);
        // },
        // showIconInput() {
        //   this.iconVisible = true;
        //   this.$nextTick(() => {
        //     this.$refs.iconTag.$refs.input.focus();
        //   });
        // },
        // handleIconConfirm() {
        //   if (this.iconValue) this.data.iconClasses.push(this.iconValue);
        //   this.iconVisible = false;
        //   this.iconValue = '';
        // }
    },
    watch: {
        'data.required': function (val) {
            if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
            else this.validator.required = null

            this.generateRule()
        },
    }
}
</script>
<style lang="scss" scoped>
.el-tag {
    vertical-align: top;
}

.el-tag+.el-tag {
    margin-left: 5px;
}

.input-new-tag {
    width: 90px;
    margin-left: 5px;
    vertical-align: bottom;
}

.color-picker {
    left: 10px;
    vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/avue/small-component/rate.vue